<template>
    <div>
        <sms-notifications-available-again />
        <sms-notifications-unavailable-banner />
        <workshop-banner />
    </div>
</template>
<script>
import SmsNotificationsUnavailableBanner from './components/SmsNotificationsUnavailableBanner.vue';
import WorkshopBanner from './components/WorkshopBanner.vue'
import SmsNotificationsAvailableAgain from './components/SmsNotificationsAvailableAgain.vue';

export default {
    name:'DashboardBanner',
    components:{
        WorkshopBanner,
        SmsNotificationsUnavailableBanner,
        SmsNotificationsAvailableAgain,
    },
}
</script>
